import { render } from "./ProjectCommentLogin.vue?vue&type=template&id=e792d24c"
import script from "./ProjectCommentLogin.vue?vue&type=script&lang=js"
export * from "./ProjectCommentLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__